import { NoBookmark as NoBookmark_kojaro } from './NoBookmark.kojaro';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    default:
      return NoBookmark_kojaro;
  }
};

export const NoBookmark = IconRenderer();
